import { createAxios } from "./createAxios";

export async function MobileOtpGenerate(mobileNo) {
    return await createAxios().post("/MobileVerification/MobileOtpGenerate",
        {
            mobileNo: mobileNo
        })
}

export async function MobileOtpVerify(mobileNo, otp) {
    return await createAxios().post("/MobileVerification/MobileOtpVerify",
        {
            mobileNo: mobileNo,
            otp: otp
        })
}

export async function CreateNewUser(param) {
    return await createAxios().post("/MobileVerification/CreateNewUser", param)
}

// export async function SearchUser(param) {
//     return await createAxios().get("/MobileVerification/SearchUser?PageNo=" +  param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm)
// }
